import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {subMenuManagement} from "../../../../utils/Constans";
import './side-nav.css';
import ChatIcon from '../../../../assets/images/chat-icon-white.png';
import WalletIcon from '../../../../assets/images/wallet.svg';
import InternalChatIcon from '../../../../assets/images/internal-chat.png';
import MyHistoryIcon from '../../../../assets/images/my-history.png';

import {getMemberRole} from "../../../../utils/General";
import config from "../../../../config";
import MenuItem from "./MenuItem";
import {connect} from "react-redux";

const styles = {
    drawer: {}
};

const SideNav = ({permissions, clients, user, company, conversationsList}) => {
    const [collapsed, setCollapsed] = useState(false);
    const role = getMemberRole(user).id;
    const {tariff} = company;
    const {features} = tariff;

    const isActiveTariff = [config.tariffStatusMap.active, config.tariffStatusMap.trial].includes(tariff.status);
    const isManager = permissions.includes(config.permissions.management);

    const [internalUnread, setInternalUnread] = useState(0);
    const [allChatsUnread, setAllChatsUnread] = useState(0);

    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setAnimate(true);
        }, 50); // small delay to ensure CSS sees the change

        return () => clearTimeout(timer);
    }, []);
    useEffect(() => {
        let internal = 0;
        let allChats = 0;

        conversationsList.forEach(conv => {
            if (conv.unread > 0) {
                if (conv.platform === config.platformsMap.company) {
                    internal += conv.unread;
                } else {
                    allChats += conv.unread;
                }
            }
        });

        setInternalUnread(internal);
        setAllChatsUnread(allChats);
    }, [conversationsList]);

    const navMenuData = [];

    // Internal Chats
    if (isActiveTariff && features.includes(config.features.INTERNAL_CHATS)) {
        navMenuData.push({
            index: -1,
            id: 'sidebar-link-member-chat',
            path: `/dashboard/chat/${config.platformsMap.company}`,
            alt: 'members-chat',
            name: 'MembersChat',
            imgSrc: InternalChatIcon,
            unread: internalUnread,
        });
    }

    // All Chats
    if (isActiveTariff && (clients.length || isManager)) {
        navMenuData.push({
            index: -1,
            id: 'sidebar-link-chat',
            path: '/dashboard/chat/all',
            name: 'all-chats',
            alt: 'all-chats',
            imgSrc: ChatIcon,
            unread: allChatsUnread,
        });
    }

    // My Space
    if (isActiveTariff && (features.includes(config.features.MY_HISTORY) || features.includes(config.features.TICKETS))) {
        navMenuData.push({
            index: -1,
            id: 'sidebar-link-my-history',
            path: '/dashboard/my/space',
            alt: 'my-space',
            name: 'My Space',
            imgSrc: MyHistoryIcon,
        });
    }

    // Client-Specific Chats
    if (isActiveTariff && user.authorities.includes(config.rolesMap.agent)) {
        clients.forEach((client, index) => {
            navMenuData.push({
                index,
                id: client.id,
                imgSrc: client.image,
                name: client.name,
                alt: 'client-chat',
                path: `/dashboard/chat/${client.id}`,
            });
        });
    }

    // Management
    const filteredSubmenus = subMenuManagement
        .filter((item) => item.permissions.includes(role))
        .filter((item) => !item.features || features.includes(item.features[0]));

    if (isManager && isActiveTariff) {
        filteredSubmenus.forEach((sm) => {
            navMenuData.push({
                index: sm.index,
                id: sm.id,
                path: sm.path,
                name: sm.name,
                alt: sm.alt,
                imgSrc: sm.imgSrc,
            });
        });
    } else if (tariff.status === config.tariffStatusMap.paymentRequired && isManager) {
        filteredSubmenus
            .filter((item) => item.name === 'Settings')
            .forEach((sm) => {
                navMenuData.push({
                    index: sm.index,
                    id: sm.id,
                    path: sm.path,
                    name: sm.name,
                    alt: sm.alt,
                    imgSrc: sm.imgSrc,
                });
            });
    }

    // Billing
    if (permissions.includes(config.permissions.billing) && features.includes(config.features.BILLING)) {
        navMenuData.push({
            index: 2000,
            id: 'sidebar-link-billing',
            path: '/dashboard/billing',
            name: 'Billing',
            alt: 'billing',
            imgSrc: WalletIcon,
        });
    }

    navMenuData.sort((a, b) => a.index - b.index);

    const onMouseLeave = () => {
        dispatchEvent(new CustomEvent("closeSidebar"));
        setCollapsed(false);
    };

    return (
        <div
            className={`parent-sidebar-div ${animate ? 'animate' : ''}`}
            style={collapsed ? {width: "200px"} : styles.drawer}
            onMouseOver={() => setCollapsed(true)}
            onMouseLeave={onMouseLeave}
        >
            <ul className="no-style-list" style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
                <div style={{marginBottom: '10px'}}/>
                {navMenuData.map((nav) => (
                    <MenuItem key={nav.id} {...nav} user={user}>
                        {nav.unread > 0 && (
                            <span className="badge">{nav.unread}</span>
                        )}
                        {nav.subMenu && nav.subMenu.length > 0 && (
                            <ul className="no-style-list submenu subMenu">
                                {nav.subMenu.map((subNav) => (
                                    <MenuItem key={subNav.id} {...subNav} user={user}/>
                                ))}
                            </ul>
                        )}
                    </MenuItem>
                ))}
            </ul>
        </div>
    );
};

SideNav.propTypes = {
    clients: PropTypes.array.isRequired,
    permissions: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    conversationsList: PropTypes.array,
};

const mapStateToProps = state => ({
    conversationsList: state.chat.conversationsList,
});


export default connect(mapStateToProps, null)(SideNav);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/side-bar/SideNav.jsx